import * as React from 'react';

import {IconButton} from 'shells/button/icon-button/icon-button';
import {EditableCurrencyField} from 'shells/formatted-number-field/editable-currency-field';
// @ts-expect-error
import {RetryRegularIcon} from 'shells/icon/svg/retry-regular-icon';
import {Stack} from 'shells/layout/stack/stack';

import styles from './value-editor.module.css';

type Props = {
    value: number;
    productValueFormatted: string;
    currencyCode: string | null | undefined;
    onSubmit: (arg1: number) => void;
    isEditing: boolean;
    setIsEditing: (arg1: boolean) => void;
    isSmall?: boolean;
    onReset: () => void;
    isInManualValueMode?: boolean;
    shouldSubmitOnBlur?: boolean;
};

export function ValueEditor(props: Props) {
    const {onReset, isInManualValueMode, productValueFormatted, ...restProps} = props;

    return (
        <Stack
            isHorizontal={true}
            isFullWidth={true}
            justifyContent='end'
            spacing={6}
            alignItems='center'
        >
            <EditableCurrencyField {...restProps} />
            {!props.isEditing && isInManualValueMode && (
                <div className={styles['reset-button']}>
                    <IconButton
                        icon={RetryRegularIcon}
                        noPadding={true}
                        onClick={onReset}
                        tooltipText={`Reset value to ${productValueFormatted} to match products`}
                    />
                </div>
            )}
        </Stack>
    );
}
